// extracted by mini-css-extract-plugin
export default {"host":"Layout_host__IdcR1","main":"Layout_main__VORBK","headerTopBarContainer":"Layout_headerTopBarContainer__C6mlD","copyright":"Layout_copyright__N8pAM"};